
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { validateMnemonic } from '@/services/account'
export default defineComponent({
  name: 'ConfirmMnemonic',
  setup() {
    const store = useStore()
    const router = useRouter()
    const mnemonicForConfirm = ref(
      'life equip reform inch author human lizard spray huge capable volume tenant'
    )

    const mnemonicConfirmed = computed(() => {
      return validateMnemonic(mnemonicForConfirm)
    })

    const nextWalletName = computed(() => {
      return `Wallet ${store.getters['wallets/accountsNum']}`
    })
    const walletName = ref(nextWalletName.value)

    function saveWallet() {
      store.dispatch('wallets/storeWallet', {
        name: walletName.value,
        address: mnemonicConfirmed.value.address,
        privateKey: mnemonicConfirmed.value.privateKey
      })
      store.commit('auth/setAuth', true)

      router.push('/swap')
    }

    return {
      store,
      router,
      walletName,
      mnemonicForConfirm,
      mnemonicConfirmed,
      saveWallet
    }
  }
})
